import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { UserContext } from "../Authcontext";
import { API_BASE_URL } from "../api_config";
import { Link } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";

export default function Sentbox() {
  const { user, token } = useContext(UserContext);
  const [likedUsers, setLikedUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.my_interest) {
      setLoading(true);
      const interestsArray = user.my_interest.split(",").map(Number);
      axios
        .post(
          `${API_BASE_URL}/api/get-user-by-my-interest`,
          { interestsArray },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        )
        .then((response) => {
          if (Array.isArray(response.data)) {
            console.log("Liked users data:", response.data);
            setLikedUsers(response.data);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching liked users:", error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [user, token]);

  if (loading) {
    return <div className="modern-loading">Loading your admires...</div>;
  }

  return (
    <div className="modern-mailbox-messages">
      {likedUsers.length === 0 ? (
        <div className="modern-empty-state">
          <div className="empty-icon"><FaHeart /></div>
          <h3>No Admires Yet</h3>
          <p>Profiles you've liked will appear here</p>
        </div>
      ) : (
        <ul className="modern-message-list">
          {likedUsers.map((profile, i) => (
            <li className="simplified-profile-card" key={i}>
              <div className="simplified-profile-avatar">
                <div 
                  className="profile-image" 
                  style={{ 
                    backgroundColor: "#f5f5f5",
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {profile.filename ? (
                    <img 
                      src={`${API_BASE_URL}/uploads/${profile.filename}`}
                      alt={profile.first_name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentNode.classList.add('show-default');
                      }}
                    />
                  ) : null}
                  <CgProfile 
                    className="default-avatar" 
                    style={{
                      display: profile.filename ? 'none' : 'block',
                      fontSize: '40px',
                      color: 'rgba(232, 67, 147, 0.3)'
                    }}
                  />
                </div>
              </div>
              
              <div className="simplified-profile-name">
                {profile.first_name}
              </div>
              
              <div className="simplified-profile-info">
                {profile.age && <div className="years">{profile.age} years</div>}
              </div>
              
              
              
              <Link
                to={"/view-profile"}
                state={{ userId: profile.user_id }}
                className="simplified-view-button"
              >
                View Full Profile
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
